// FNP-1191 CRUD half — the zone lifecycle mutations (FNP-1219).
//
// ⚠️ THERE IS NO UPDATE MUTATION, AND THAT IS NOT AN OMISSION.
//
// The neutral schema exposes exactly two zone writes: `createDnsZone` and
// `deleteDnsZone`. Verified against the DEPLOYED TEST API
// (appsync s73pkluu7fc4teo3wbc53qwubq, us-west-2) — no `updateDnsZone` and no
// `UpdateDnsZoneInput` exist anywhere in the introspected SDL.
//
// That is a design position rather than a gap. A zone's mutable surface IS its
// records, and those are a sibling feature (`/zones/:zoneId/records`, FNP-1192)
// with a mutation set of their own. The only zone-level fields — `name`,
// `isPrivate`, `nameservers` — are either immutable at every provider or
// changed through a different operation entirely (`canSetNameservers`). So this
// module has NO edit drawer and NO row-click-to-edit; writing one would mean
// calling a field that is not on the schema, which is a runtime validation
// error rather than a TODO.

// The selection set matches the read half's DNS_ZONE_FIELDS exactly, so a
// created zone lands in the cache in the same shape `listDnsZones` returns.
// A narrower create selection would put a half-populated row in the table
// until the next refetch, which reads as data loss.
const DNS_ZONE_FIELDS = `
    id
    name
    connectionId
    provider
    isPrivate
    nameservers
    appearsDelegated
`;

// ⚠️ RETURNS THE WHOLE ZONE, NOT AN ID.
//
// The schema chose a full `DnsZone` return so the caller never constructs one,
// and so `nameservers` arrive with it. ⚠️ Those may be EMPTY, and empty means
// "not yet assigned" rather than "publishes none" — Route 53 assigns at
// creation, a provider that activates asynchronously may not. The success
// notification says which rather than showing a bare count of zero.
export const createDnsZone = `
    mutation createDnsZone($input: CreateDnsZoneInput!) {
        createDnsZone(input: $input) {${DNS_ZONE_FIELDS}}
    }
`;

// ⚠️ RETURNS A PAYLOAD, NOT A BOOLEAN. `true` says nothing a caller can act on,
// and this operation has a refusal the console must explain rather than
// swallow. The echoed id is what lets a list drop the right row.
export const deleteDnsZone = `
    mutation deleteDnsZone($input: DeleteDnsZoneInput!) {
        deleteDnsZone(input: $input) {
            id
            connectionId
        }
    }
`;
